// Fetch categories from the API
import instance from "../../utils/axios";

export const startProductTime = async (productID) => {
  try {
    if (!productID) {
      throw new Error("Product ID is required.");
    }
    return await instance.get(
      `/start-time-in-product/${encodeURIComponent(productID)}`
    );
  } catch (error) {
    console.error("Error fetching products:", error.message);
    throw error; // Rethrow for further handling
  }
};
